import React, { useState, useEffect, useRef } from "react";
import CommonObj from "../../CommonObj";
import { useAuthToken } from "../../components/usecontext/AuthContext";
import Html5QrcodePlugin from "../qrscanner/qrscanner";
import { Modal, Radio, Input, DatePicker } from "antd";
import { message } from "../../components/antdMessageBridge";
import CuttingIcon from "../../assets/img/svg/xcuttingtitleicon.svg";
// import "./cutting.css";
import "./change-status.css";
import "./datepicker-override.css";
import SliderUI from "../manifest/manifest-slide";
// import BatchProcess from "./cutting-batch";
import { Html5QrcodeScanType } from "html5-qrcode";
import BookCoverDummy from "../../assets/img/cover.png";
import { useAuth } from "../../auth/AuthContext";
import { useReworkData } from "../../components/errorCommentsSlider/userreworkdata";
import ErrorCommentsSlider from "../../components/errorCommentsSlider/errorcomments-slider";
import { encryptTimestamp } from "../../components/commoncsrf/csrf-common";
import ConfirmationModal from "../../components/confirmationmodal/confirmation-modal";
import regexService, {
    removeSpaces,
} from "../../components/commonregex/regexService";
import IntakeSlide from "../books/Intake-reject-slide";
import dayjs from "dayjs";

const ChangeStatus = () => {
    // Store previous station end time for validation
    const [prevStationEndTime, setPrevStationEndTime] = useState("");
    const [form, setForm] = useState({
        bid: "",
        title: "",
        isbN10: "",
        isbN13: "",
        bookPageCount: "",
        station: "",
        currentCompletedStation: "", // New field from API
        nextStation: "", // New field from API
        roundNumber: "",
        startDateAndTime: "",
        endDateAndTime: "",
        weight: "0.75",
        isbn: "",
        condition: "",
        content: "",
        bookFormat: "",
        round: "",
        rackAndShelf: "1",
        rackShelf: "",
        comments: "",
        bookType: "",
        reasonForException: "",
        newRackShelf: "",
        formatException: "",
        usedCondition: "Acceptable",

    });
    const {
        reworkDrawerVisible,
        reworkData,
        loading,
        openReworkDrawer,
        closeReworkDrawer,
        hasQcStatus,
        roundName,
        refreshReworkData,
    } = useReworkData(form.bid);
    const [currentBidForComments, setCurrentBidForComments] = useState("");
    const [batchData, setBatchData] = useState([]);
    const [text, setText] = useState([]);

    const { roleUserId } = useAuth();
    const drawerOpenedForBid = useRef(null);
    const [isbnInput, setIsbnInput] = useState("");
    const [showRoundNameButton, setShowRoundNameButton] = useState(false);
    const [load, setLoad] = useState(false);
    const { accessToken } = useAuthToken();
    const [lockBidInput, setLockBidInput] = useState(false);
    const [isModalVisible, setIsModalVisible] = useState(false);
    const [rejectSubmissionData, setRejectSubmissionData] = useState(null);

    function filterUniqueScans(results) {
        const filteredResults = [];
        if (results.length === 0) {
            return filteredResults;
        }
        filteredResults.push(results[0]);
        for (let i = 1; i < results.length; ++i) {
            if (results[i].decodedText !== results[i - 1].decodedText) {
                filteredResults.push(results[i]);
            }
        }
        return filteredResults;
    }
    const [bookCover, setBookCover] = useState(false);
    const [regexLoaded, setRegexLoaded] = useState(false);

    const [masterData, setMasterData] = useState({
        bookFormat: [],
        condition: [],
        eqComplexityLevelFormula: [],
        bookFormatExceptions: [],
        language: [],
    });
    const [languageData, setLanguageData] = useState([]);
    const [selectedLanguage, setSelectedLanguage] = useState("");
    const [langErrorMsg, setLangErrorMsg] = useState("");
    const UserDetails = JSON.parse(localStorage.getItem("user"));
    const LogoText = UserDetails?.name?.toUpperCase() || "U";

    useEffect(() => {
        return () => {
            Modal.destroyAll();
        };
    }, []);

    useEffect(() => {
        const fetchMasterData = async () => {
            try {
                const response = await fetch(CommonObj.Endpoints.GetMasterData, {
                    method: "GET",
                    mode: "cors",
                    headers: {
                        Authorization: `Bearer ${accessToken}`,
                        "X-CSRF-Token": encryptTimestamp(),
                        "Content-Type": "application/json",
                    },
                });

                if (!response.ok) {
                    throw new Error(`HTTP error! Status: ${response.status}`);
                }
                const data = await response.json();
                setMasterData(data);
            } catch (error) {
                console.error("Failed to fetch master data:", error);
            }
        };

        fetchMasterData();
    }, []);

    useEffect(() => {
        const fetchLanguageData = async () => {
            try {
                const response = await fetch(CommonObj.Endpoints.GetLanguageListwithCode, {
                    method: "GET",
                    mode: "cors",
                    headers: {
                        Authorization: `Bearer ${accessToken}`,
                        "X-CSRF-Token": encryptTimestamp(),
                        "Content-Type": "application/json",
                    },
                });


                if (!response.ok) {
                    throw new Error(`HTTP error! Status: ${response.status}`);
                }
                const data = await response.json();
                setLanguageData(data);
            } catch (error) {
                console.error("Failed to fetch language data:", error);
            }
        };

        fetchLanguageData();
    }, []);

   

    useEffect(() => {
        if (
            !form.bookFormat ||
            form.content.length === 0 ||
            masterData.eqComplexityLevelFormula.length === 0
        ) {
            setForm((prev) => ({ ...prev, eqComplexityLevel: "" }));
            return;
        }

        const bookFormatObj = masterData.bookFormat.find(
            (bf) => bf.format === form.bookFormat,
        );
        if (!bookFormatObj) return;

        const selectedConditionIds = form.content
            .map((contentName) => {
                const conditionObj = masterData.condition.find(
                    (c) => c.fileType === contentName,
                );
                return conditionObj ? conditionObj.id.toString() : null;
            })
            .filter((id) => id !== null);

        let bestMatch = null;
        for (const formula of masterData.eqComplexityLevelFormula) {
            if (formula.bookFormat !== bookFormatObj.id.toString()) {
                continue;
            }

            const formulaConditions = formula.condition.split(",");

            if (
                formulaConditions.length === selectedConditionIds.length &&
                formulaConditions.every((condId) =>
                    selectedConditionIds.includes(condId),
                )
            ) {
                bestMatch = formula;
                break;
            }
        }

        if (bestMatch) {
            setForm((prev) => ({ ...prev, eqComplexityLevel: bestMatch.level }));
            setErrors((prev) => ({
                ...prev,
                ["eqComplexityLevel"]: "",
            }));
        } else {
            setForm((prev) => ({ ...prev, eqComplexityLevel: "" }));
        }
    }, [form.bookFormat, form.content, masterData]);
    const saveComment = async () => {
        if (!currentBidForComments.trim()) {
            message.warning("No BID selected for saving comments.");
            return;
        }
        if (!form.comments.trim()) {
            message.warning("Please enter a comment before saving.");
            return;
        }
        const payload = {
            bid: currentBidForComments,
            comments: form.comments,
            createdBy: roleUserId,
        };
        setLoad(true);
        try {
            const response = await fetch(CommonObj.Endpoints.InsertComments, {
                method: "POST",
                headers: {
                    Authorization: `Bearer ${accessToken}`,
                    "X-CSRF-Token": encryptTimestamp(),
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(payload),
            });
            if (!response.ok) {
                throw new Error(`Server responded with status ${response.status}`);
            }
            message.success("Comment saved successfully!");
            setForm((prev) => ({ ...prev, comments: "" }));

            openCommentsSlider(currentBidForComments);
        } catch (error) {
            message.error(`Failed to save comment`);
        } finally {
            setLoad(false);
        }
    };

    const [errors, setErrors] = useState({});
    const [activeScanner, setActiveScanner] = useState(null);
    const [decodedResults, setDecodedResults] = useState([]);
    const [visible, setVisible] = useState(false);
    const [commentsvisible, setCommentsVisible] = useState(false);
    const [processingMode, setProcessingMode] = useState("single");
    const [commentsList, setCommentsList] = useState([]);

    const openCommentsSlider = async (bid) => {
        if (!bid) {
            message.warning("Please enter BID before viewing comments.");
            return;
        }

        setCurrentBidForComments(bid);
        try {
            const response = await fetch(CommonObj.Endpoints.GetComments, {
                method: "POST",
                headers: {
                    Authorization: `Bearer ${accessToken}`,
                    "X-CSRF-Token": encryptTimestamp(),
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    pageNo: 1,
                    pageSize: 10,
                    search: bid,
                }),
            });
            if (!response.ok) {
                throw new Error(`Status ${response.status}`);
            }
            const data = await response.json();

            setCommentsList(data);
            setCommentsVisible(true);
        } catch (error) {
            message.error(`Failed to fetch comments`);
        }
    };
    useEffect(() => {
        const loadRegexPatterns = async () => {
            try {
                await regexService.fetchRegexData(accessToken);
                setRegexLoaded(true);
            } catch (error) {
                console.error("Failed to load regex patterns:", error);
            }
        };

        if (accessToken) {
            loadRegexPatterns();
        }
    }, [accessToken]);
    const handleModeChange = (e) => {
        setProcessingMode(e.target.value);
    };
    useEffect(() => {
        const uniqueResults = filterUniqueScans(decodedResults);

        if (uniqueResults.length > 0 && activeScanner) {
            const latestResult = uniqueResults[uniqueResults.length - 1];
            const scannedValue = latestResult.decodedText;

            switch (activeScanner) {
                case "ISBN":
                    setForm((prev) => ({ ...prev, isbn: scannedValue }));
                    break;
                case "BID":
                    if (document.activeElement && document.activeElement.name === "bid") {
                        setIsbnInput(prev => prev ? prev + "," + scannedValue : scannedValue);
                    } else {
                        setForm((prev) => ({ ...prev, bid: scannedValue }));
                        setIsbnInput(scannedValue);
                        UserLogin(scannedValue);
                    }
                    break;
                case "Rack & Shelf ID":
                    setForm((prev) => ({ ...prev, newRackShelf: scannedValue }));
                    break;
                default:
                    break;
            }
            setActiveScanner(null);
            setDecodedResults([]);
        }
    }, [decodedResults, activeScanner]);

    const onNewScanResult = (decodedText, decodedResult) => {
        setDecodedResults((prev) => [...prev, decodedResult]);
    };

    const handleContentChange = (e) => {
        const { name, value, checked } = e.target;

        setForm((prev) => {
            const currentContent = prev.content;

            if (checked) {
                return { ...prev, content: [...currentContent, value] };
            } else {
                return {
                    ...prev,
                    content: currentContent.filter((item) => item !== value),
                };
            }
        });
        if (errors[name]) {
            setErrors((prev) => {
                const newErrors = { ...prev };
                delete newErrors[name];
                return newErrors;
            });
        }
    };
    const handleChange = (e) => {
        const { name, value } = e.target;

        if (errors[name]) {
            setErrors((prev) => ({ ...prev, [name]: "" }));
        }
        if (errors[name]) {
            setErrors((prev) => {
                const newErrors = { ...prev };
                delete newErrors[name];
                return newErrors;
            });
        }
    };
    const validateBid = (value) => {
        const regex = /^BID[A-Za-z0-9\-]{13}$/;

        if (!value) {
            return "Please Enter / Scan the BID number of the book.";
        } else if (!regex.test(value)) {
            return "Must start with 'BID' and should have 16 characters.";
        } else if (value.length !== 16) {
            return "BID Value must be 16 chars (alphanumeric, hyphens only).";
        } else if (!value.startsWith("BID")) {
            return 'BID Value must start with "BID".';
        } else if (!value.includes("-")) {
            return "BID Value must include at least one hyphen.";
        } else {
            return "";
        }
    };
    const validate = () => {
        const newErrors = {};

        const checkRequired = (field, key, msg) => {
            if (!field || !String(field).trim()) newErrors[key] = msg;
        };

        // BID
        if (!form?.bid?.trim()) {
            newErrors.bid = "Please Enter / Scan the BID number of the book";
        } else {
            const bidErr = validateBid(form.bid);
            if (bidErr) newErrors.bid = bidErr;
        }

        checkRequired(form.roundNumber, "roundNumber", "Round is required");
        checkRequired(form.station, "station", "Station is required");
        checkRequired(form.startDateAndTime, "startDateAndTime", "Start Date is required");
        checkRequired(form.endDateAndTime, "endDateAndTime", "End Date is required");

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const validateIdentifiers = (errors) => {
        const charRegex = /^[0-9\s-]*$/;
        const charRegexNew = /^[A-Za-z0-9\s-]*$/;

        if (!form?.bid?.trim()) {
            setVisible(false);
            errors.bid = "Please Enter / Scan the BID number of the book";
        } else {
            const bidErr = validateBid(form.bid);
            if (bidErr) { setVisible(false); errors.bid = bidErr; }
        }

        if (!form.isbn?.trim()) errors.isbn = "Please Enter / Scan the ISBN number";
        else if (!charRegex.test(form.isbn)) errors.isbn = "Invalid characters in ISBN.";

        if (!form.isbN10?.trim()) errors.isbN10 = "ISBN-10 is required";
        else if (!charRegexNew.test(form.isbN10)) errors.isbN10 = "Invalid characters in ISBN-10.";

        if (!form.isbN13?.trim()) errors.isbN13 = "ISBN-13 is required";
        else if (!charRegexNew.test(form.isbN13)) errors.isbN13 = "Invalid characters in ISBN-13.";
    };

    const validateComplexity = (errors) => {
        const integerRegex = /^[0-9]*$/;

        if (!form.bookPageCount || Number(form.bookPageCount) <= 0) {
            errors.bookPageCount = "Page count must be greater than 0";
        } else if (!integerRegex.test(form.bookPageCount)) {
            errors.bookPageCount = "Page count must be whole number";
        }

        if (form.condition === "Used Condition" && !form.usedCondition?.trim()) {
            errors.usedCondition = "Wear Level is required";
        }
        if (form.bookFormat !== "Exceptions" && !form.eqComplexityLevel?.trim()) {
            errors.eqComplexityLevel = "EQ-Complexity Level is required";
        }
        if (form.bookFormat === "Exceptions" && !form.formatException) {
            errors.formatException = "Reason for exception is required";
        }
        if (!Array.isArray(form.content) || form.content.length === 0) {
            errors.content = "At least one content type must be selected";
        }
    };

    const validateRackShelfLogic = (errors) => {
        const newRack = form.newRackShelf?.trim();
        if (!newRack) {
            errors.newRackShelf = "Rack and Shelf is required";
            return;
        }

        const isSame = removeSpaces(form.rackShelf).toLowerCase() === removeSpaces(newRack).toLowerCase();
        if (isSame) {
            errors.newRackShelf = "Must not be the same as current Rack Shelf.";
        } else if (regexLoaded && !regexService.validateRackShelf(newRack).isValid) {
            errors.newRackShelf = "Input format invalid: No matching pattern found.";
        }
    };
    const [isDisabled, setIsDisabled] = useState(false);
    const handleSubmit = async (e) => {
        e.preventDefault();

        setTemporaryDisable();
        if (!validate()) return;

        const newStart = dayjs(form.startDateAndTime);
        const newEnd = dayjs(form.endDateAndTime);
        if (newEnd.isBefore(newStart)) {
            message.error("End Date/Time cannot be less than Start Date/Time.");
            return;
        }

        if (form.station === form.nextStation && form.currentCompletedStation) {
            try {
                const prevData = await fetchStationHistory(form.bid, form.currentCompletedStation);
                const prevRecord = Array.isArray(prevData) ? prevData[0] : prevData;
                const prevEndTime = prevRecord && prevRecord.endDateAndTime ? prevRecord.endDateAndTime : "";
                if (prevEndTime) {
                    const prevEnd = dayjs(prevEndTime);
                    if (newStart.isBefore(prevEnd) || newEnd.isBefore(prevEnd)) {
                        message.error("Next station's Start Date cannot be less than the current station's End Date.");
                        return;
                    }
                }
            } catch (err) {
                message.error("Could not validate previous station time. Please try again.");
                return;
            }
        }

        const submissionData = prepareSubmissionData();

        if (submissionData.BID) {
            await processSubmission(submissionData);
        }
    };

    const setTemporaryDisable = () => {
        setIsDisabled(true);
        setTimeout(() => setIsDisabled(false), 2000);
    };

    const prepareSubmissionData = () => {
        return {
            BID: form.bid.trim(),
            RoundNumber: form.roundNumber,
            StationName: form.station,
            StartTime: dayjs(form.startDateAndTime).format("YYYY-MM-DDTHH:mm:ss"),
            EndTime: dayjs(form.endDateAndTime).format("YYYY-MM-DDTHH:mm:ss"),
            //StartTime: form.startDateAndTime,
            //EndTime: form.endDateAndTime,
            userId: roleUserId,
            createdBy: roleUserId,
            Comments: form.comments,
        };
    };

    const processSubmission = async (submissionData) => {
        try {
            const response = await fetch(CommonObj.Endpoints.SubmitUpsertStationTimes, {
                method: "POST",
                headers: {
                    Authorization: `Bearer ${accessToken}`,
                    "X-CSRF-Token": encryptTimestamp(),
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(submissionData),
            });
            const result = await response.json();
            if (!response.ok) {
                const errorMessage = result.error || result.message || `Error ${response.status}`;
                throw new Error(errorMessage);
            }
            handleSuccess(submissionData);
            resetFormState();
            UserLogin(form.bid);
        } catch (error) {
            message.error({ content: error.message, duration: 5 });
            setLockBidInput(false);
        }
    };

    const handleSuccess = (data) => {
        if (data.condition === "Used Condition" && data.usedCondition === "Unacceptable") {
            message.success("Book got cancelled due to unacceptable wear level");
        } else {
            message.success("Updated Data Successfully");
        }


    };

    const resetFormState = () => {
        setShowRoundNameButton(false);
        setIsbnInput("");
        setCommentsList([]);
        setErrors({});
        setSelectedLanguage("");
        setForm({
            
            bookType: "", usedCondition: "", content: [], bookFormat: "",
            eqComplexityLevel: "", rackAndShelf: "", comments: "",
            reasonForException: "", formatException: "", newRackShelf: "",
            rackShelf: "", version: "1.0"
        });
        setLockBidInput(false);
    };
    const fetchStationHistory = async (bid, stationName) => {
        try {
            const response = await fetch(CommonObj.Endpoints.GetManualTimeStationHistory, {
                method: "POST",
                mode: "cors",
                headers: {
                    Authorization: `Bearer ${accessToken}`,
                    "X-CSRF-Token": encryptTimestamp(),
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({ bid, stationName }),
            });
            const data = await response.json();
            console.log("GetManualTimeStationHistory response:", data);
            return data;
        } catch (error) {
            console.error("GetManualTimeStationHistory error:", error);
            clearDates();
        }
    };
    const clearDates = () => {
        setForm(prev => ({
            ...prev,
            startDateAndTime: "",
            endDateAndTime: ""
        }));
    };
    const handleStationChange = async (e) => {
        const { value } = e.target;
        handleChange(e);
        setForm(prev => ({ ...prev, station: value }));
        if (value && form.bid) {
            try {
                const data = await fetchStationHistory(form.bid, value);
                const record = Array.isArray(data) ? data[0] : data;
                console.log("Station history record:", record);
                if (record && record.startDateAndTime) {
                    setForm(prev => ({
                        ...prev,
                        startDateAndTime: record.startDateAndTime,
                        endDateAndTime: record.endDateAndTime || ""
                    }));
                    // If this is the next station, store the previous station's end time for validation
                    if (value === form.nextStation && form.currentCompletedStation) {
                        // Fetch previous station's end time
                        const prevData = await fetchStationHistory(form.bid, form.currentCompletedStation);
                        const prevRecord = Array.isArray(prevData) ? prevData[0] : prevData;
                        setPrevStationEndTime(prevRecord && prevRecord.endDateAndTime ? prevRecord.endDateAndTime : "");
                    } else {
                        setPrevStationEndTime("");
                    }
                } else {
                    setForm(prev => ({
                        ...prev,
                        startDateAndTime: "",
                        endDateAndTime: ""
                    }));
                    setPrevStationEndTime("");
                }
            }
            catch (error) {
                // Scenario: Fetch caught an error (actual 404 status code)
                console.error("Error fetching station history:", error);
                clearDates();
                setPrevStationEndTime("");
            }
        }
    };

    async function UserLogin(bid) {
        setLoad(true);
        try {
            const response = await fetchBookDatanew(bid);
            if (!response.ok) throw new Error(`Response status: ${response.status}`);

            const result = await response.json();
            const data = Array.isArray(result) ? result[0] : result;

            // Check for rejectionStatus
            if (data && data.rejectionStatus && data.rejectionStatus.trim() !== "") {
                message.error(data.rejectionStatus);
                setLockBidInput(false);
                return; // Block next steps
            }

            if (data && (data.nextStation || data.roundNumber !== undefined)) {
                handleSuccessfulLogin(data, bid);
                setLockBidInput(true);
            } else {
                handleEmptyLogin();
                setLockBidInput(false);
            }

        } catch (error) {
            setShowRoundNameButton(false);
            setLockBidInput(false);
            console.error(error.message);
        }
        finally {
            setLoad(false);
        }
    }




    const handleSuccessfulLogin = async (bookData, bid) => {
        setErrors({});
        const resolvedBid = bid || bookData.bid || form.bid;
        const defaultStation = bookData.currentCompletedStation || form.currentCompletedStation;
        setForm(prev => ({
            ...prev,
            bid: resolvedBid,
            station: defaultStation,
            currentCompletedStation: bookData.currentCompletedStation || prev.currentCompletedStation,
            nextStation: bookData.nextStation || prev.nextStation,
            roundNumber: bookData.roundNumber != null ? String(bookData.roundNumber) : prev.roundNumber,
            startDateAndTime: "",
            endDateAndTime: "",
        }));

        setBookCover(bookData.bookCoverImageURL);
        setSelectedLanguage(bookData.language);
        fetchCommentCount(resolvedBid);

        // Auto-populate dates for the default (current) station
        if (defaultStation && resolvedBid) {
            try {
                const data = await fetchStationHistory(resolvedBid, defaultStation);
                const record = Array.isArray(data) ? data[0] : data;
                if (record && record.startDateAndTime) {
                    setForm(prev => ({
                        ...prev,
                        startDateAndTime: record.startDateAndTime,
                        endDateAndTime: record.endDateAndTime || "",
                    }));
                }
            } catch (error) {
                console.error("Error fetching station history on login:", error);
            }
        }
    };


    const handleEmptyLogin = () => {
        setIsbnInput("");
        setCommentsList({});
        setErrors({});
        setShowRoundNameButton(false);
        setSelectedLanguage("");
        setForm({
            title: "", author: "", publisher: "", isbN10: "", isbN13: "",
            bookPageCount: "", updbookPageCount: "", language: "", weight: "0.75",
            isbn: "", condition: "", bookType: "", usedCondition: "", content: [],
            bookFormat: "", eqComplexityLevel: "", rackAndShelf: "", comments: "",
            reasonForException: "", formatException: "", rackShelf: "",
            version: "1.0", qc: "",
        });
        setLockBidInput(false);
    };

    const fetchBookDatanew = (bid) => {
        return fetch(CommonObj.Endpoints.GetBookChangeByBIDandStatus, {
            method: "POST",
            mode: "cors",
            headers: {
                Authorization: `Bearer ${accessToken}`,
                "X-CSRF-Token": encryptTimestamp(),
                "Content-Type": "application/json",
            },
            body: JSON.stringify({ bid, createdBy: roleUserId }),
        });
    };
  
    const handleFormKeyDown = (e) => {
        if (e.key === 'Enter' && e.target.tagName !== 'TEXTAREA') {
            e.preventDefault();
            e.stopPropagation();
            return false;
        }
    };
    const handleClear = () => {
        if (form.bid || form.newRackShelf || form.comments) {
            ConfirmationModal.showClearConfirmation(() => {
                setIsbnInput("");
                setSelectedLanguage("");
                setForm({
                    bid: "",
                    title: "",
                    author: "",
                    publisher: "",
                    isbN10: "",
                    isbN13: "",
                    bookPageCount: "",
                    language: "",
                    weight: 0.75,
                    isbn: "",
                    condition: "",
                    usedCondition: "",
                    content: [],
                    bookFormat: "",
                    eqComplexityLevel: "",
                    rackAndShelf: "",
                    comments: "",
                    reasonForException: "",
                    version: "",
                    rackShelf: "",
                    newRackShelf: "",
                });
                setCommentsList([]);
                setErrors({}); 
                setShowRoundNameButton(false);
                setLockBidInput(false);
                drawerOpenedForBid.current = null;
            });
        }
    };

    const fetchCommentCount = async (bid) => {
        if (!bid) return;

        try {
            const response = await fetch(CommonObj.Endpoints.GetComments, {
                method: "POST",
                headers: {
                    Authorization: `Bearer ${accessToken}`,
                    "X-CSRF-Token": encryptTimestamp(),
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    pageNo: 1,
                    pageSize: 10,
                    search: bid,
                }),
            });
            if (!response.ok) {
                throw new Error(`Status ${response.status}`);
            }
            const data = await response.json();
            setCommentsList(data);
        } catch (error) {
            console.error(`Failed to fetch comments`);
        }
    };

    const populateFieldsByIsbn = async (bid) => {
        setForm((prev) => ({
            ...prev,
            bid: bid,
        }));
        UserLogin(bid);
    };
    const handleIsbnBlur = () => {
        if (form.bid && form.bid.trim() !== "" && form.bid.trim().length !== 16) {
            message.error("The BID should be 16 characters");
            return;
        }
        //if (selectedLanguage && isLanguageInactive(selectedLanguage)) {
        //    message.warning("Selected language is currently inactive.");
        //}
        if (isbnInput.trim() !== "") {
            populateFieldsByIsbn(isbnInput);
            clearDates();
        }
    };

    const handleSubmitIsbn = (e) => {
        setForm((prev) => ({
            ...prev,
            bid: isbnInput,
        }));
    };

    const handleBlur = () => {
        if (form.bid) {
            UserLogin(form.bid);
        }
    };

    const handleIsbnInputChange = (e) => {
        const value = e.target.value;
        setIsbnInput(value);

        if (value.trim() === "") {
            setForm({
                bid: "",
                title: "",
                author: "",
                publisher: "",
                isbN10: "",
                isbN13: "",
                bookPageCount: "",
                language: "",
                weight: 0.75,
                isbn: "",
                condition: "",
                bookType: "",
                usedCondition: "",
                content: [],
                bookFormat: "",
                eqComplexityLevel: "",
                comments: "",
                reasonForException: "",
                rackAndShelf: "",
                rackShelf: "",
                newRackShelf: "",
                version: 1.0,
            });
            setBookCover("");
            setSelectedLanguage([]);
                        setErrors({})

        } else {
            setForm((prev) => ({
                ...prev,
                bid: value,
                startDateAndTime: "",
                endDateAndTime: "",
                station: "",
                currentCompletedStation: "",
                nextStation: "",
            }));
        }
    };

    const handleIsbnKeyPress = (e) => {
        if (e.key === "Enter") {
            e.preventDefault();
            if (form.bid && form.bid.trim() !== "" && form.bid.trim().length !== 16) {
                message.error("The BID should be 16 characters");
                return;
            }
            if (isbnInput.trim() !== "") {
                populateFieldsByIsbn(isbnInput);
            }
        }
    };

    const handleNumericKeyDown = (event) => {
        if (["e", "E", "+", "-", "."].includes(event.key)) {
            event.preventDefault();
        }
    };
    function MasterRadio(item) {
        return (
            <div className="book-page-form-radio-button">
                <input
                    type="radio"
                    name={item?.name}
                    id="book-page-form-radio-binding-t1-book"
                    value={item?.data?.format}
                    checked={item?.value === item?.data?.format}
                    onChange={handleChange}
                />
                <label htmlFor="book-page-form-radio-binding-t1-book">
                    {item?.data?.format}
                </label>
            </div>
        );
    }

    function MasterCheckbox(item) {
        return (
            <div className="book-page-form-checkbox-button">
                <input
                    type="checkbox"
                    id="used-condition-content1"
                    name={item?.name}
                    value={item?.data?.fileType}
                    checked={form?.content?.includes(item?.data?.fileType)}
                    onChange={handleContentChange}
                />
                <label htmlFor="used-condition-content">{item?.data?.fileType}</label>
            </div>
        );
    }

    const showRejectModal = (record) => {
        if (!validate()) return;
        const submissionData = prepareSubmissionData();
        console.log("reject model open");
        setIsModalVisible(true);
        setRejectSubmissionData(submissionData);
    };
    const getInputClass = (value, baseClass = "book-page-form-input-text") => {
        return `${baseClass}${value ? " has-text" : ""}`;
    };
    return (
        <>
            <IntakeSlide
                isModalVisible={isModalVisible}
                setIsModalVisible={setIsModalVisible}
                clearForm={resetFormState}
                title={"Cutting Reject"}
                rejectSubmissionData={rejectSubmissionData}
                oldRackandShelf={form?.rackShelf}
                onScannerOpen={(scanner) => { setActiveScanner(scanner) }}
                emptyDecode={() => { setDecodedResults([]) }}
                className="story-slider slider-with-footer"
                width={540}
            />
            <Modal
                title={`Scan ${activeScanner ? activeScanner : ""}`}
                open={!!activeScanner}
                onCancel={() => setActiveScanner(null)}
                footer={null}
                destroyOnClose
                width={1000}
                className="scan-model-container"
            >
                <div className="scan-modal">
                    <Html5QrcodePlugin
                        fps={30}
                        qrbox={{ width: 1000, height: 400 }}
                        aspectRatio={2.8}
                        disableFlip={false}
                        qrCodeSuccessCallback={onNewScanResult}
                        supportedScanTypes={[Html5QrcodeScanType.SCAN_TYPE_CAMERA]}
                    />
                </div>
            </Modal>
            <SliderUI
                visible={visible}
                width={450}
                title="Book Slide"
                onClose={() => setVisible(false)}
                imageSrc={bookCover ? bookCover : BookCoverDummy}
                bookTitle={form.title}
                isbn={form.isbn}
                bid={form.bid}
                bookscover={true}
                mode={processingMode}
                className="story-slider"
                modeBatch={text}
                batchData={batchData}
            />
            <SliderUI
                visible={commentsvisible}
                width={390}
                title="Comments Slide"
                onClose={() => setCommentsVisible(false)}
                bookTitle={`Comments For BID : ${form.bid}`}
                commentsList={commentsList}
                commentsCount={commentsList.length > 0 ? commentsList[0].totalRows : 0}
                username={form.createdBy}
                form={form}
                setForm={setForm}
                saveComment={saveComment}
                load={load}
                className="story-slider comment-slider-drawer-1"
            />

            <ErrorCommentsSlider
                visible={reworkDrawerVisible}
                onClose={closeReworkDrawer}
                reworkData={reworkData}
                loading={loading}
                hasQcStatus={hasQcStatus}
            />
            <main className="book-page-main-container">
                <div className="book-page-container changestatus-page">
                    <div className="book-page-title-container no-padding-right">
                        <div className="book-page-title">
                            <span>
                                <img src={CuttingIcon} alt="Cutting Icon"></img>
                            </span>

                            <h2>Book Station Time Updates
                            </h2>
                        </div>
                        <div className="book-page-title-container-2">
                        </div>
                    </div>
                    {processingMode === "single" ? (
                        <form
                            className="book-page-form no-right-padding"
                            onSubmit={handleSubmit}
                            onKeyDown={handleFormKeyDown}
                            noValidate
                        >
                            <div className="flex-container-BID">
                                <div className="book-page-camera-button-container multiple rounded-button">
                                    <Input
                                        placeholder=""
                                        value={isbnInput}
                                        className={`${isbnInput ? "has-id" : ""}`}
                                        onChange={handleIsbnInputChange}
                                        onBlur={handleIsbnBlur}
                                        onKeyDown={handleIsbnKeyPress}
                                        id="cutting-isbn-input-id"
                                    />
                                    {isbnInput.length === 0 && (
                                        <label htmlFor="cutting-isbn-input-id">
                                            Enter BID / Scan BID Number Using “
                                            <strong>Camera Icon</strong>”
                                            <span className="form-required">*</span>
                                        </label>
                                    )}
                                    <button
                                        type="button"
                                        className="book-page-camera-button"
                                        onClick={() => setActiveScanner("BID")}
                                    >
                                        <svg
                                            width="24"
                                            height="24"
                                            viewBox="0 0 24 24"
                                            fill="none"
                                            xmlns="http://www.w3.org/2000/svg"
                                        >
                                            <circle
                                                cx="12"
                                                cy="13"
                                                r="3"
                                                stroke="#1C274C"
                                                strokeWidth="1.5"
                                            />
                                            <path
                                                opacity="0.5"
                                                d="M10 19.9999H14C16.8089 19.9999 18.2134 19.9999 19.2223 19.3258C19.659 19.0339 20.034 18.6589 20.3259 18.2222C21 17.2133 21 15.8088 21 12.9999C21 10.191 20.9999 8.78673 20.3257 7.77783C20.0339 7.34107 19.6589 6.96607 19.2221 6.67423C18.2132 6.00011 16.8088 6.00011 13.9999 6.00011H9.99985C7.19093 6.00011 5.78646 6.00011 4.77757 6.67423C4.34081 6.96607 3.96581 7.34107 3.67397 7.77783C3 8.7865 3 10.1903 3 12.998L3 12.9999C3 15.8088 3 17.2133 3.67412 18.2222C3.96596 18.6589 4.34096 19.0339 4.77772 19.3258C5.78661 19.9999 7.19108 19.9999 10 19.9999Z"
                                                stroke="#1C274C"
                                                strokeWidth="1.5"
                                            />
                                            <path
                                                d="M18 10H17.5"
                                                stroke="#1C274C"
                                                strokeWidth="1.5"
                                                strokeLinecap="round"
                                            />
                                            <path
                                                opacity="0.5"
                                                d="M14.5 3.5H9.5"
                                                stroke="#1C274C"
                                                strokeWidth="1.5"
                                                strokeLinecap="round"
                                            />
                                        </svg>
                                        <svg
                                            width="24"
                                            height="24"
                                            viewBox="0 0 24 24"
                                            fill="none"
                                            xmlns="http://www.w3.org/2000/svg"
                                        >
                                            <path
                                                fillRule="evenodd"
                                                clipRule="evenodd"
                                                d="M8.00098 4C8.00098 3.44772 8.41425 3 8.92405 3H15.0779C15.5877 3 16.001 3.44772 16.001 4C16.001 4.55228 15.5877 5 15.0779 5H8.92405C8.41425 5 8.00098 4.55228 8.00098 4Z"
                                                fill="url(#paint0_linear_273_6917)"
                                            />
                                            <path
                                                fillRule="evenodd"
                                                clipRule="evenodd"
                                                d="M9.77875 21H14.2232C17.3442 21 18.9047 21 20.0257 20.2777C20.511 19.965 20.9277 19.5632 21.252 19.0953C22.001 18.0143 22.001 16.5095 22.001 13.4999C22.001 10.4903 22.0008 8.9857 21.2518 7.90473C20.9275 7.43676 20.5109 7.03497 20.0256 6.72228C18.9046 6 17.3441 6 14.223 6H9.77859C6.65756 6 5.09705 6 3.97605 6.72228C3.49077 7.03497 3.0741 7.43676 2.74984 7.90473C2.00098 8.98547 2.00098 10.4896 2.00098 13.4979L2.00098 13.4999C2.00098 16.5095 2.00098 18.0143 2.75 19.0953C3.07426 19.5632 3.49093 19.965 3.97622 20.2777C5.09721 21 6.65773 21 9.77875 21ZM7.83431 13.4999C7.83431 11.2808 9.69979 9.48196 12.001 9.48196C14.3022 9.48196 16.1676 11.2808 16.1676 13.4999C16.1676 15.7189 14.3022 17.5178 12.001 17.5178C9.69979 17.5178 7.83431 15.7189 7.83431 13.4999ZM9.50098 13.4999C9.50098 12.1685 10.6203 11.0891 12.001 11.0891C13.3817 11.0891 14.501 12.1685 14.501 13.4999C14.501 14.8313 13.3817 15.9106 12.001 15.9106C10.6203 15.9106 9.50098 14.8313 9.50098 13.4999ZM18.1121 9.48196C17.6519 9.48196 17.2788 9.84174 17.2788 10.2855C17.2788 10.7294 17.6519 11.0891 18.1121 11.0891H18.6676C19.1279 11.0891 19.501 10.7294 19.501 10.2855C19.501 9.84174 19.1279 9.48196 18.6676 9.48196H18.1121Z"
                                                fill="url(#paint1_linear_273_6917)"
                                            />
                                            <defs>
                                                <linearGradient
                                                    id="paint0_linear_273_6917"
                                                    x1="22.601"
                                                    y1="11.9503"
                                                    x2="1.98296"
                                                    y2="14.3301"
                                                    gradientUnits="userSpaceOnUse"
                                                >
                                                    <stop stopColor="#033D9B" />
                                                    <stop offset="1" stopColor="#29ACD5" />
                                                </linearGradient>
                                                <linearGradient
                                                    id="paint1_linear_273_6917"
                                                    x1="22.601"
                                                    y1="11.9503"
                                                    x2="1.98296"
                                                    y2="14.3301"
                                                    gradientUnits="userSpaceOnUse"
                                                >
                                                    <stop stopColor="#033D9B" />
                                                    <stop offset="1" stopColor="#29ACD5" />
                                                </linearGradient>
                                            </defs>
                                        </svg>
                                    </button>
                                    <button
                                        type="button"
                                        className="book-page-camera-button-input-2"
                                        onClick={handleSubmitIsbn}
                                    >
                                        <svg
                                            width="20"
                                            height="20"
                                            viewBox="0 0 20 20"
                                            fill="none"
                                            xmlns="http://www.w3.org/2000/svg"
                                        >
                                            <path
                                                fillRule="evenodd"
                                                clipRule="evenodd"
                                                d="M20 10C20 15.5228 15.5228 20 10 20C4.47715 20 0 15.5228 0 10C0 4.47715 4.47715 0 10 0C15.5228 0 20 4.47715 20 10ZM11.0303 6.46967C10.7374 6.17678 10.2626 6.17678 9.96967 6.46967C9.67678 6.76256 9.67678 7.23744 9.96967 7.53033L12.4393 10L9.96967 12.4697C9.67678 12.7626 9.67678 13.2374 9.96967 13.5303C10.2626 13.8232 10.7374 13.8232 11.0303 13.5303L14.0303 10.5303C14.3232 10.2374 14.3232 9.76256 14.0303 9.46967L11.0303 6.46967ZM5.96967 6.46967C6.26256 6.17678 6.73744 6.17678 7.03033 6.46967L10.0303 9.46967C10.3232 9.76256 10.3232 10.2374 10.0303 10.5303L7.03033 13.5303C6.73744 13.8232 6.26256 13.8232 5.96967 13.5303C5.67678 13.2374 5.67678 12.7626 5.96967 12.4697L8.43934 10L5.96967 7.53033C5.67678 7.23744 5.67678 6.76256 5.96967 6.46967Z"
                                                fill="url(#paint0_linear_1900_8687)"
                                            />
                                            <defs>
                                                <linearGradient
                                                    id="paint0_linear_1900_8687"
                                                    x1="20.6"
                                                    y1="9.94475"
                                                    x2="-0.0696504"
                                                    y2="12.0919"
                                                    gradientUnits="userSpaceOnUse"
                                                >
                                                    <stop stopColor="#033D9B" />
                                                    <stop offset="1" stopColor="#29ACD5" />
                                                </linearGradient>
                                            </defs>
                                        </svg>
                                    </button>
                                </div>
                                {showRoundNameButton && (
                                    <button
                                        type="button"
                                        className="round-btn"
                                        onClick={openReworkDrawer}
                                    >
                                        {roundName}{" "}
                                        <span>
                                            <svg
                                                width="14"
                                                height="14"
                                                viewBox="0 0 14 14"
                                                fill="none"
                                                xmlns="http://www.w3.org/2000/svg"
                                            >
                                                <g clipPath="url(#clip0_4317_52426)">
                                                    <circle
                                                        opacity="0.5"
                                                        cx="7.0013"
                                                        cy="6.99935"
                                                        r="5.83333"
                                                        stroke="#DC1400"
                                                        strokeWidth="0.875"
                                                    />
                                                    <path
                                                        d="M6.125 5.25L7.875 7L6.125 8.75"
                                                        stroke="#DC1400"
                                                        strokeWidth="0.875"
                                                        strokeLinecap="round"
                                                        strokeLinejoin="round"
                                                    />
                                                </g>
                                                <defs>
                                                    <clipPath id="clip0_4317_52426">
                                                        <rect width="14" height="14" fill="white" />
                                                    </clipPath>
                                                </defs>
                                            </svg>
                                        </span>
                                    </button>
                                )}
                            </div>
                            <div className="field-group bid-change">
                                <input
                                    id="bid"
                                    name="bid"
                                    className={getInputClass(form?.bid)}
                                    value={form.bid}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    placeholder=""
                                    required
                                    disabled={lockBidInput}
                                />
                                <label htmlFor="bid" className="label">
                                    Scan Book Id (BID){" "}
                                    <span className="form-required">*</span>
                                </label>
                                <button
                                    className="book-page-form-input-camera-icon"
                                    type="button"
                                    onClick={() => {
                                        setDecodedResults([]);
                                        setActiveScanner("BID");
                                    }}
                                >
                                    <svg
                                        width="16"
                                        height="16"
                                        viewBox="0 0 16 16"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                    >
                                        <circle cx="8" cy="8.66669" r="2" stroke="#1C274C" />
                                        <path
                                            opacity="0.5"
                                            d="M6.66673 13.3333H9.3334C11.206 13.3333 12.1423 13.3333 12.8149 12.8839C13.1061 12.6894 13.3561 12.4393 13.5507 12.1482C14.0001 11.4756 14.0001 10.5393 14.0001 8.66666C14.0001 6.79404 14 5.85788 13.5506 5.18528C13.356 4.89411 13.106 4.64411 12.8148 4.44955C12.1422 4.00014 11.2059 4.00014 9.3333 4.00014H6.66663C4.79402 4.00014 3.85771 4.00014 3.18511 4.44955C2.89394 4.64411 2.64394 4.89411 2.44938 5.18528C2.00007 5.85773 2.00007 6.79363 2.00007 8.66542L2.00007 8.66666C2.00007 10.5393 2.00007 11.4756 2.44948 12.1482C2.64404 12.4393 2.89404 12.6894 3.18521 12.8839C3.85781 13.3333 4.79412 13.3333 6.66673 13.3333Z"
                                            stroke="#1C274C"
                                        />
                                        <path
                                            d="M12.0001 6.66669H11.6667"
                                            stroke="#1C274C"
                                            strokeLinecap="round"
                                        />
                                        <path
                                            opacity="0.5"
                                            d="M9.66659 2.33331H6.33325"
                                            stroke="#1C274C"
                                            strokeLinecap="round"
                                        />
                                    </svg>
                                    <svg
                                        width="16"
                                        height="16"
                                        viewBox="0 0 16 16"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                    >
                                        <path
                                            fillRule="evenodd"
                                            clipRule="evenodd"
                                            d="M5.33398 2.66667C5.33398 2.29848 5.6095 2 5.94937 2H10.0519C10.3918 2 10.6673 2.29848 10.6673 2.66667C10.6673 3.03486 10.3918 3.33333 10.0519 3.33333H5.94937C5.6095 3.33333 5.33398 3.03486 5.33398 2.66667Z"
                                            fill="url(#paint0_linear_1086_13749)"
                                        />
                                        <path
                                            fillRule="evenodd"
                                            clipRule="evenodd"
                                            d="M6.51917 14H9.48213C11.5628 14 12.6032 14 13.3505 13.5185C13.674 13.31 13.9518 13.0422 14.168 12.7302C14.6673 12.0095 14.6673 11.0063 14.6673 8.99992C14.6673 6.99352 14.6672 5.99047 14.1679 5.26982C13.9517 4.95784 13.6739 4.68998 13.3504 4.48152C12.603 4 11.5627 4 9.48202 4H6.51906C4.43837 4 3.39803 4 2.6507 4.48152C2.32718 4.68998 2.0494 4.95784 1.83322 5.26982C1.33398 5.99031 1.33398 6.99307 1.33398 8.99859L1.33398 8.99992C1.33398 11.0063 1.33398 12.0095 1.83333 12.7302C2.04951 13.0422 2.32729 13.31 2.65081 13.5185C3.39814 14 4.43848 14 6.51917 14ZM5.22287 8.99992C5.22287 7.52056 6.46653 6.32131 8.00065 6.32131C9.53478 6.32131 10.7784 7.52056 10.7784 8.99992C10.7784 10.4793 9.53478 11.6785 8.00065 11.6785C6.46653 11.6785 5.22287 10.4793 5.22287 8.99992ZM6.33398 8.99992C6.33398 8.11231 7.08018 7.39275 8.00065 7.39275C8.92113 7.39275 9.66732 8.11231 9.66732 8.99992C9.66732 9.88754 8.92113 10.6071 8.00065 10.6071C7.08018 10.6071 6.33398 9.88754 6.33398 8.99992ZM12.0747 6.32131C11.7679 6.32131 11.5192 6.56116 11.5192 6.85703C11.5192 7.1529 11.7679 7.39275 12.0747 7.39275H12.4451C12.7519 7.39275 13.0007 7.1529 13.0007 6.85703C13.0007 6.56116 12.7519 6.32131 12.4451 6.32131H12.0747Z"
                                            fill="url(#paint1_linear_1086_13749)"
                                        />
                                        <defs>
                                            <linearGradient
                                                id="paint0_linear_1086_13749"
                                                x1="15.0673"
                                                y1="7.96685"
                                                x2="1.32197"
                                                y2="9.55339"
                                                gradientUnits="userSpaceOnUse"
                                            >
                                                <stop stopColor="#033D9B" />
                                                <stop offset="1" stopColor="#29ACD5" />
                                            </linearGradient>
                                            <linearGradient
                                                id="paint1_linear_1086_13749"
                                                x1="15.0673"
                                                y1="7.96685"
                                                x2="1.32197"
                                                y2="9.55339"
                                                gradientUnits="userSpaceOnUse"
                                            >
                                                <stop stopColor="#033D9B" />
                                                <stop offset="1" stopColor="#29ACD5" />
                                            </linearGradient>
                                        </defs>
                                    </svg>
                                </button>

                                {errors.bid && (
                                    <span className="error-msg">{errors.bid}</span>
                                )}
                            </div>
                            <div className="cs-form-grid">
                                {/* Row 3: Round & Station (1fr 1fr) */}
                                <div className="cs-row-split">
                                    <div className="field-group">
                                        <select
                                            id="roundNumber"
                                            name="roundNumber"
                                            className={getInputClass(form?.roundNumber)}
                                            value={form.roundNumber}
                                            onChange={handleChange}
                                        >
                                            <option value=""></option>
                                            {form.roundNumber !== "" && form.roundNumber !== null && form.roundNumber !== undefined && (
                                                <option value={form.roundNumber}>Round {form.roundNumber}</option>
                                            )}
                                        </select>
                                        <label htmlFor="roundNumber" className="label">
                                            Round <span className="form-required">*</span>
                                        </label>
                                        {errors.roundNumber && (
                                            <span className="error-msg">{errors.roundNumber}</span>
                                        )}
                                    </div>
                                    <div className="field-group cs-field-narrow">
                                        <select
                                            id="station"
                                            name="station"
                                            className={getInputClass(form?.station)}
                                            value={form.station}
                                            onChange={handleStationChange}
                                        >
                                            <option value=""></option>
                                            {form.currentCompletedStation && (
                                                <option value={form.currentCompletedStation}>
                                                    {form.currentCompletedStation} (Current)
                                                </option>
                                            )}
                                            {form.nextStation && (
                                                <option value={form.nextStation}>
                                                    {form.nextStation} (Next)
                                                </option>
                                            )}
                                        </select>
                                        <label htmlFor="station" className="label">
                                            Station <span className="form-required">*</span>
                                        </label>
                                        {errors.station && (
                                            <span className="error-msg">{errors.station}</span>
                                        )}
                                    </div>
                                </div>

                                {/* Row 4: Start Date & End Date (1fr 1fr) */}
                                <div className="cs-row-split">
                                    <div className="field-group">
                                        <DatePicker
                                            id="startDateAndTime"
                                            name="startDateAndTime"
                                            value={form.startDateAndTime ? dayjs(form.startDateAndTime) : null}
                                            onChange={(date, dateString) => {
                                                setForm(prev => ({ ...prev, startDateAndTime: dateString }));
                                                if (errors.startDateAndTime) {
                                                    setErrors(prev => ({ ...prev, startDateAndTime: "" }));
                                                }
                                            }}
                                            placeholder=""
                                            showTime
                                            format="YYYY-MM-DD HH:mm:ss"
                                            className={`${getInputClass(form?.startDateAndTime)} cs-datepicker-full`}
                                            disabledDate={current => current && current > dayjs().endOf('day')}
                                            popupClassName="changestatus-datepicker-override"
                                            dropdownClassName="changestatus-datepicker-override"
                                        />
                                        <label htmlFor="startDateAndTime" className="label">
                                            Start Date <span className="form-required">*</span>
                                        </label>
                                        {errors.startDateAndTime && (
                                            <span className="error-msg">{errors.startDateAndTime}</span>
                                        )}
                                    </div>
                                    <div className="field-group cs-field-narrow">
                                        <DatePicker
                                            id="endDateAndTime"
                                            name="endDateAndTime"
                                            value={form.endDateAndTime ? dayjs(form.endDateAndTime) : null}
                                            onChange={(date, dateString) => {
                                                setForm(prev => ({ ...prev, endDateAndTime: dateString }));
                                                if (errors.endDateAndTime) {
                                                    setErrors(prev => ({ ...prev, endDateAndTime: "" }));
                                                }
                                            }}
                                            placeholder=""
                                            showTime
                                            format="YYYY-MM-DD HH:mm:ss"
                                            className={`${getInputClass(form?.endDateAndTime)} cs-datepicker-full`}
                                            disabledDate={current => current && current > dayjs().endOf('day')}
                                            popupClassName="changestatus-datepicker-override"
                                            dropdownClassName="changestatus-datepicker-override"
                                        />
                                        <label htmlFor="endDateAndTime" className="label">
                                            End Date <span className="form-required">*</span>
                                        </label>
                                        {errors.endDateAndTime && (
                                            <span className="error-msg">{errors.endDateAndTime}</span>
                                        )}
                                    </div>
                                </div>

                                {/* Row 5: Comments (Full Width) */}
                                <div className="cs-row-full">
                                    <div className="field-group cs-comments-field">
                                        <textarea
                                            id="comments"
                                            rows="4"
                                            value={form.comments}
                                            onChange={(e) =>
                                                setForm((prev) => ({ ...prev, comments: e.target.value }))
                                            }
                                            className={`book-page-form-input-textarea ${form.comments ? "has-text" : ""}`}
                                        ></textarea>
                                        <label htmlFor="comments">Comments</label>
                                    </div>
                                </div>
                            </div>

                            <div className="book-page-footer-container">
                                <div className="book-page-action-container cs-actions-right">
                                    <div className="book-page-buttons-container justify-space">
                                        <button
                                            type="button"
                                            className="reject-button"
                                            onClick={handleClear}
                                        >
                                            Clear
                                        </button>
                                        <button
                                            className="accept-button"
                                            disabled={isDisabled || (form.station !== "" && form.station === form.currentCompletedStation)}
                                        >
                                            Submit
                                        </button>
                                        {/* <button className="reject-button" type="button" disabled={isDisabled} onClick={() => showRejectModal()}>Reject</button> */}

                                    </div>
                                </div>
                            </div>
                        </form>
                    ) : (
                        <></>
                        // <BatchProcess
                        //     title="Begin The Batch Process"
                        //     onDataChange={setBatchData}
                        //     onBatch={setText}
                        // />
                    )}
                </div>
            </main>
        </>
    );
};
export default ChangeStatus;
